//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { RB_HEADER_CONTAINER, MOBILE_PANELS } from '@/scripts/constants/css-classes'
import { DESKTOP } from '@/scripts/constants/media-query'
import PDP from '@/scripts/libs/pdp'
import TryLens from '@/scripts/libs/try-lens'
const RbPill = () => import(/* webpackChunkName: "editorial-chunk" */ '@/elements/pill/pill.vue')
import RbPanel from '@/elements/panel/rb-panel.vue'

export default {
  name: 'rb-lens-details-panel',
  components: {
    RbPill,
    RbPanel,
  },
  data() {
    return {
      lensDescription: '',
      cLens: '',
      isMaskEnabled: false,
      visible: false,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    getBackgroundImage() {
      return this.isMaskEnabled
        ? TryLens.getMaskImage(this.cLens)
        : TryLens.getBaseImage(this.cLens)
    },
    getMiniatureImage() {
      return TryLens.getLensSwatch(this.cLens)
    },
    isDesktop() {
      return this.$mq === DESKTOP
    },
  },
  mounted() {
    window.externalInvocationMethodMapping.showLensDetailsPanel = (param) => {
      if (this.isDesktop) {
        /* TODO: Refer to rb-panel instead */
        const mobilePanel = document.getElementsByClassName(MOBILE_PANELS)[0]
        if (mobilePanel) {
          const headerHeight = document
            .querySelector(`.${RB_HEADER_CONTAINER}`)
            ?.getBoundingClientRect()?.height
          mobilePanel.style.top = `${headerHeight ?? 0}px`
        }
      }
      this.visible = true
      this.cLens = param.cLens
      this.getDraggableLensesEspotContent(param.cLens)
    }
  },
  methods: {
    handleClosePanel() {
      this.visible = false
    },
    showMaskImage() {
      this.isMaskEnabled = true
    },
    hideMaskImage() {
      this.isMaskEnabled = false
    },
    async getDraggableLensesEspotContent(cLens) {
      this.lensDescription = ''
      const lensDetails = await PDP.fetchLensDetails(cLens)
      this.lensDescription = lensDetails.description
    },
  },
}
